module.exports = __webpack_public_path__ + "static/saltwire-logo-95b003d129e25ac4a00754d7927d9c36.jpeg";